import { z } from 'zod';

export const LinkCompartihamentoPageTipoSchema = z
    .enum(['NFe', 'nfe', 'NFCe', 'nfce', 'NFSe', 'nfse', 'venda'])
    .optional()
    .transform((tipo) => {
        if (!tipo || tipo === 'venda') {
            return 'venda' as const;
        }

        return tipo.toLowerCase() as 'nfe' | 'nfce' | 'nfse';
    });

export type LinkCompartilhamentoTipo = z.infer<typeof LinkCompartihamentoPageTipoSchema>;
